import React from "react";
import "./css/Home.css";
import { Link } from 'react-scroll';
import { motion } from "framer-motion";

export default function Home() {
  return (
    <div className="home-bg">
      {/* Video Background */}
      <video
        className="video-bg"
        src="/videos/TIMELAPSE_SUNSET_1.mp4"
        autoPlay
        loop
        muted
        playsInline
      />

      <motion.div
        className="home-content"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <div className="home-profile-block">
          <img
            src="/images/your-avatar.png"
            alt="Avatar"
            className="profile-avatar"
          />
          <div className="status-badge">
            <span className="status-dot" /> Available for new projects
          </div>
        </div>
        <h1 className="home-title">
          Building Exceptional<br />Projects
        </h1>
        <p className="home-desc">
          I specialize in transforming designs and requirements into functional, high-performing applications. Let's discuss your next project.
        </p>
        <div className="home-btn-group">
        <Link
                  key='projects'
                  to='projects'
                  smooth={true}
                  duration={500}
                  offset={-70}
                  spy={true}
                  className="home-btn-outline"
          >
            Explore My Work <span className="arrow">&#8595;</span>
          </Link>
        <Link
                  key='contact'
                  to='contact'
                  smooth={true}
                  duration={500}
                  offset={-70}
                  spy={true}
                  className="home-btn-outline"
          >
            <span role="img" aria-label="wave">👋</span> Let's Connect
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
